import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../lib/cn";

export const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-sm px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.05em]",
  {
    variants: {
      variant: {
        neutral: "border border-charcoal-200 text-charcoal-600",
        primary: "border border-primary-600 text-primary-700",
        gold: "border border-sand-600 text-sand-700",
        info: "border border-primary-600/60 text-clinical-info",
        success: "border border-primary-600/60 text-clinical-success",
        warning: "border border-sand-300 text-clinical-warning",
        high: "border border-sand-600 text-clinical-high",
        critical: "bg-clinical-criticalBg border border-clinical-critical text-clinical-critical",
      },
    },
    defaultVariants: { variant: "neutral" },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
